import { DownloadOutlined } from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { Button, Dropdown } from 'antd'

import { AppAdmin } from 'api/app-admin'
import { EXPORT_TYPE } from 'constants/export-file'
import { downloadBlob, generateFilename } from 'utils/download-file'
import { logError } from 'utils/logger'

interface ExportCSVV2Props {
  className?: string
  filters?: Record<string, any>
}

const ExportCSVV2 = ({ className, filters }: ExportCSVV2Props) => {
  const handleExport = async (fetchFn: () => Promise<any>, type: string) => {
    try {
      const response = await fetchFn()
      downloadBlob(response.data, generateFilename(type), 'text/csv')
    } catch (error: any) {
      logError(error)
    }
  }

  const menuItems: MenuProps['items'] = [
    {
      key: EXPORT_TYPE.VESTING_HMC_V2.KEY,
      label: EXPORT_TYPE.VESTING_HMC_V2.LABEL,
      onClick: () =>
        handleExport(
          () => AppAdmin.exportByType(EXPORT_TYPE.VESTING_HMC_V2.KEY, filters),
          EXPORT_TYPE.VESTING_HMC_V2.KEY
        ),
    },
    {
      key: EXPORT_TYPE.VESTING_VENTURE_V2.KEY,
      label: EXPORT_TYPE.VESTING_VENTURE_V2.LABEL,
      onClick: () =>
        handleExport(
          () => AppAdmin.exportByType(EXPORT_TYPE.VESTING_VENTURE_V2.KEY, filters),
          EXPORT_TYPE.VESTING_VENTURE_V2.KEY
        ),
    },
  ]

  return (
    <div className={className}>
      <Dropdown menu={{ items: menuItems }} trigger={['click', 'hover']} placement="bottomRight">
        <Button type="primary" icon={<DownloadOutlined />}>
          Export CSV
        </Button>
      </Dropdown>
    </div>
  )
}

export default ExportCSVV2
